import Formatter from "@/utils/Formatter";
var displayPriceMixin = {
    methods: {
        displayPrice: function (value) {
            var dollarAmount = Formatter.centsToDollars(value);
            return "$" + dollarAmount;
        }
    },
};
export default displayPriceMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/displayPriceMixin.ts
// module id = W7yA
// module chunks = 18